module.exports = __webpack_public_path__ + "media/images/div_lens/masonry-img-4-bd0952b8461025089eb9a72676506d5a.png";